/**
 * Punto de entrada de la aplicación. Renderiza React.StrictMode con AuthProvider y BrowserRouter.
 */
import React from "react";
import ReactDOM from "react-dom/client";
import App from "App";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "AuthContext";
import { validateEnv } from "utils/config/env";

validateEnv();

if (process.env.NODE_ENV === "development") {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    const msg = args[0];
    if (
      typeof msg === "string" &&
      (msg.includes("findDOMNode is deprecated") ||
        msg.includes("validateDOMNesting") ||
        msg.includes("Static function can not consume context"))
    ) {
      return;
    }
    originalWarn(...args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Router>
        <App />
      </Router>
    </AuthProvider>
  </React.StrictMode>
);
